// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Wz-z","modalContent":"Xz-z","header":"Yz-z","close":"Zz-z"};